import { useAuth } from '../../../../hooks/useAuth';
import { CONVERSATION_RETENTION_DAYS, useGetAiConversations } from '../../api/useGetAiConversations';
import { formatConversationDate, getConversationAuthor } from '../../utils/conversationLabels';

export function useConversationList() {
  const { user } = useAuth();
  const { data, isLoading, error } = useGetAiConversations();

  const rows = (data ?? []).map((conversation) => ({
    id: conversation.id,
    sender: getConversationAuthor(conversation, user?.id),
    subject: conversation.title,
    preview: conversation.lastMessagePreview ?? undefined,
    date: formatConversationDate(conversation.updatedAt),
    dateTime: conversation.updatedAt,
  }));

  return {
    rows,
    isLoading,
    hasError: Boolean(error),
    subtitle: `${CONVERSATION_RETENTION_DAYS} derniers jours · partagées avec les membres`,
  };
}
